import React from "react";

const Icon = ({ children }) => <span className="icon">{children}</span>;

export default Icon;
